import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { QuotingToolService } from '../../quoting-tool.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-service-req',
  templateUrl: './service-req.component.html'
})
export class ServiceReqComponent implements OnInit {

  imagePath:any=environment.image_path;

  @ViewChild('serviceSelection') serviceSelectionModal: ElementRef | undefined;

  infoText:string="You are modifying the selected services.The questions will be updated accordingly.If you deselect a service, related data will be lost.";

  serviceList:any[]=[];
  selectedServiceList:any[]=[];
  tempRemovedServiceList:any[]=[];
  tempSelectedServiceList:any[]=[];
  questionArray:any[]=[];
  notFilled:any=[];
 
  projectID:any;
  uniqueID:any;
  activeServiceId:any;
  activeServiceName:any;
  activeServiceIsSubmitted:boolean=false;
  preventServiceDoubleClick:boolean=false;
  finalSubmission:boolean=false;

  @ViewChild('serviceRequired') serviceRequired !:ElementRef;

  constructor(private notifyService: NotificationService,private modalService: NgbModal,private quotingService:QuotingToolService) { }

  ngOnInit(): void {
    this.projectID = localStorage.getItem('projectID');
    this.GetAllServices();
    localStorage.setItem('currentStepIndex', '0');
  }

  ngOnDestroy(){
    this.modalService.dismissAll();
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.uniqueID = localStorage.getItem('ID');
      this.GetServiceRequirements();
    }, 300);
  }

  trackByQuestionId(index: number, item: any): any {
    return item.iMasterQuestionId;  // Ensure you return a unique identifier for each item
  }

  trackById(index: number, item: any): any {
    return item.id;  // Ensure you return a unique identifier for each item
  }
  
  GetAllServices(){
 
    this.quotingService.GetAllMasterServices().subscribe((result: any) => {
      if (result['code'] == 200) {
        this.serviceList=result.data;
      } else {
        this.notifyService.showError(result.message, '');
      }
    });
    
  }

  GetServiceRequirements(redirectFlag?:boolean){    
    this.quotingService.GetSelectedServices(this.uniqueID).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.selectedServiceList=result.data;
        if(redirectFlag==true){
          this.RedirectToNextStep();
          return;
        }
        if(!this.activeServiceId && this.selectedServiceList.length>0){
          this.activeServiceId=this.selectedServiceList[0].iMasterServiceId;
          this.activeServiceName=this.selectedServiceList[0].vMasterServiceTitle;
          this.activeServiceIsSubmitted = this.selectedServiceList[0].isSubmitted;
          this.GetServiceQuestions(this.activeServiceId,this.activeServiceName,true);
        }else if(this.activeServiceId && this.selectedServiceList.length>0){
          const foundElement = this.selectedServiceList.find((obj:any)=>this.activeServiceId==obj.iMasterServiceId);
          if(foundElement){
            this.activeServiceIsSubmitted = foundElement.isSubmitted;
            this.GetServiceQuestions(this.activeServiceId,this.activeServiceName,true);
          }else{
            this.activeServiceId=this.selectedServiceList[0].iMasterServiceId;
            this.activeServiceName=this.selectedServiceList[0].vMasterServiceTitle;
            this.activeServiceIsSubmitted = this.selectedServiceList[0].isSubmitted;
            this.GetServiceQuestions(this.activeServiceId,this.activeServiceName,true);
          }
        }
    
        setTimeout(()=>{
          const storedIndex = localStorage.getItem('currentStepIndex');
          if (this.projectID && this.selectedServiceList.length==0 && storedIndex=='0') {
            this.OpenServiceSelectionModal(this.serviceSelectionModal);
          }
        },500)
      } else {
        this.notifyService.showError(result.message, '');
      }
    });    
  }


  GetServiceQuestions(id:any,vMasterServiceTitle:any,skipFlag:boolean=false){
    if(this.preventServiceDoubleClick){
      return;
    }
    this.preventServiceDoubleClick=true;

    if(skipFlag==false){
      if(this.questionArray.length>0){
        const foundEmpty = this.questionArray.find((element:any) => (element.iMasterQuestionType<4 && element.answers.length==0) || (element.iMasterQuestionType==4 && element.hasOwnProperty('inputValue') && (element.inputValue==='' || element.inputValue===null || element.inputValue<0 || element.inputValue?.toString().includes('-') || element.inputValue?.toString().includes('.'))));
        if(foundEmpty){
            this.activeServiceIsSubmitted=false;
            this.UpdateServiceRequirementAnswers(this.activeServiceId,this.uniqueID,this.questionArray);
        }else{
            this.activeServiceIsSubmitted=true;
            this.UpdateServiceRequirementAnswers(this.activeServiceId,this.uniqueID,this.questionArray);
        }    
      }
    }
    
    this.quotingService.GetServiceQuestions(id).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.activeServiceId=id;
        this.activeServiceName=vMasterServiceTitle;
        this.questionArray=result['data'];
        this.GetAnswerArray();
      } else {
        this.notifyService.showError(result.message, '');
        this.preventServiceDoubleClick=false;
      }
    });
    
  }
  
  GetAnswerArray(){
    this.quotingService.GetServiceQuestionsAnswers(this.uniqueID,this.activeServiceId).subscribe((result: any) => {
      if (result['code'] == 200) {
          this.questionArray=this.questionArray.map((obj:any)=>{
            const foundElement=result['data'].vQuestionArray.find((element:any)=>element.iMasterQuestionId==obj.iMasterQuestionId);
            if(foundElement){
              obj['answers']=foundElement.answers;
              if(foundElement.iMasterQuestionType==4){
                obj['inputValue'] = Number(foundElement.iDefaultValue);
                obj['iDefaultValue']=Number(foundElement.iDefaultValue);
                if(Number(foundElement.inputValue)>=0){
                  obj['inputValue']=Number(foundElement.inputValue);
                }
              }
            }
            return obj;
          });
          this.preventServiceDoubleClick=false;
      } else {
        this.notifyService.showError(result.message, '');
        this.preventServiceDoubleClick=false;
      }
    });
  }


  UpdateServiceRequirementAnswers(iMasterServiceId:any,iProjectId:any,answerArray:any,redirectFlag?:boolean){
      const finalAnswerArray = answerArray.map((obj:any)=>{
        let finalAnswer = this.setPriorityParameter(obj)
        return finalAnswer;
      })
    
      let reqJson={
        iMasterServiceId: iMasterServiceId,
        iProjectId: iProjectId,
        isSubmitted:this.activeServiceIsSubmitted,
        vQuestionArray: finalAnswerArray
      }
  
      this.quotingService.UpdateServiceRequirement(reqJson).subscribe((result: any) => {
        if (result['code'] == 200) {
          // this.notifyService.showSuccess(result.message, '');
          this.GetServiceRequirements(redirectFlag);
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
  }

  setPriorityParameter(question:any){
    switch(question.iMasterQuestionType){
      case 1:
        question['priority'] = question['answers'][0]?.priority;
        return question;
      case 2:
          if(question['answers'].length>0){
              if(question['priorityCheck']==true){
                if(question['answers'].length==1){
                  question['priority']=1;
                }else if(question['answers'].length==2){
                  question['priority']=2;
                }else{
                  question['priority']=3;
                }
              }
            }
        return question;
      case 3:
        question['priority'] = question['answers'][0]?.priority;
        return question;
      case 4:
        question['answers'] = question['vMasterQuestionOptions'];
        return question;
      case 5:
        if(question['answers'].length>0){
            question['priority']=1;
            question['answers'].forEach((element:any) => {
              if(question['priority'] && question['priority']<element.priority){
                question['priority']=element.priority;
              }
            });
          }
          return question;
      default:
        console.log("Unknown selection type");
        return question;
    }
  }

  optionChange(event:any,question:any,option?:any){
    switch(question.iMasterQuestionType){
      case 1:
        question['answers']=[option];
        question['priority'] = option.priority;
        break;
      case 2:
          if(question['answers'].length>0){
            if(event.checked==false){  
              const indexAnswer = question['answers'].findIndex((answer:any)=>option.opt == answer.opt);
              if(indexAnswer>-1){
                question['answers'].splice(indexAnswer, 1);
              }
            }else if(event.checked==true){
              question['answers'].push(option);
              if(question['priorityCheck']==true){
                if(question['answers'].length==2){
                  question['priority']=2;
                }else{
                  question['priority']=3;
                }
              }
            }
          }else{
            question['answers']=[option];
            if(question['priorityCheck']==true){
              question['priority']=1;
            }
          }
        break;
      case 3:
        question['answers']=[option];
        question['priority'] = option.priority;
        break;
      case 4:
        const key = event.key;

        // Allow numeric keys (0-9), backspace, arrow keys, delete, and '.'
        if (
          (key >= '0' && key <= '9') || // 0-9
          key === 'Backspace' || // backspace
          key === 'ArrowLeft' || // left arrow
          key === 'ArrowRight' || // right arrow
          key === 'Delete' 
        ) {
          return; // Let the input proceed
        }
    
        // If it's not a valid number, prevent the input
        event.preventDefault();
        question['inputValue'] = Number(event.target.value);
        break;
      case 5:
        if(question['answers'].length>0){
          if(event.checked==false){  
            const indexAnswer = question['answers'].findIndex((answer:any)=>option.opt == answer.opt);
            if(indexAnswer>-1){
              question['answers'].splice(indexAnswer, 1);
            }
          }else if(event.checked==true){
            question['answers'].push(option);
            question['priority']=1;
            question['answers'].forEach((element:any) => {
              if(question['priority'] && question['priority']<element.priority){
                question['priority']=element.priority;
              }
            });
          }
        }else{
          question['answers']=[option];
          question['priority'] = option.priority;
        }
      break;
      default:
        console.log("Unknown selection type");
        break;
    }
  }

  CheckBindAnswer(question:any,option?:any):any{
    switch(question.iMasterQuestionType){
      case 1:
        return question.answers.length>0 && question.answers[0].opt == option.opt ? true : false;
      case 2:
        const found = question.answers.find((obj:any)=>option.opt == obj.opt);
        return found ? true : false;
      case 3:
        return question.answers.length>0 && question.answers[0].opt == option.opt ? true : false;
      case 4:
        return question.hasOwnProperty('inputValue') && question.hasOwnProperty('inputValue') !=null ? question['inputValue'] : question['iDefaultValue'];
      case 5:
        const foundCheck = question.answers.find((obj:any)=>option.opt == obj.opt);
        return foundCheck ? true : false;
      default:
        return false;
    }
  }

  OpenServiceSelectionModal(ModalName:any){
    this.modalService.open(ModalName, { centered: true, windowClass: 'serivce-custom-modal', size: 'lg' });
    this.tempSelectedServiceList=[...this.selectedServiceList];
    this.tempRemovedServiceList=[];
    if(this.questionArray.length>0){
      this.UpdateServiceRequirementAnswers(this.activeServiceId,this.uniqueID,this.questionArray);
    }
  }

  SaveServiceRequirement(){
    let reqJson={
      iProjectId:this.uniqueID,
      data:this.tempSelectedServiceList, //selected
      removed:this.tempRemovedServiceList
    }

    this.quotingService.AddServiceRequirement(reqJson).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.modalService.dismissAll();
        this.notifyService.showSuccess(result.message, '');
        this.questionArray=[];
        this.GetServiceRequirements();
      } else {
        this.notifyService.showError(result.message, '');
      }
    });

  }

  CheckSelected(service_id:any){
    const found = this.tempSelectedServiceList.find((service)=>service_id == service.iMasterServiceId);
    return found ? true : false;
  }

  ServiceSelection(event:any,service:any){
    if(event.checked===true){
      this.tempSelectedServiceList.push(service);
      const index = this.tempRemovedServiceList.findIndex((obj:any)=>service._id==obj.iMasterServiceId);
      if(index>-1){
      this.tempRemovedServiceList.splice(index, 1);
      }
    }else{
      const index = this.tempSelectedServiceList.findIndex((obj:any)=>service._id==obj.iMasterServiceId);
      if(index>-1){
        this.tempSelectedServiceList.splice(index, 1);
      }
      this.tempRemovedServiceList.push(service);
    }
  }

  OpenServiceRequiredModal(){
    this.modalService.open(this.serviceRequired, { centered: true, windowClass: 'serivce-custom-modal', size: 'sm' });
  }

  Okay(){
    if(this.notFilled.length>0){
      if(this.notFilled[0]['iMasterServiceId']!=this.activeServiceId){
        this.GetServiceQuestions(this.notFilled[0].iMasterServiceId,this.notFilled[0].vMasterServiceTitle);
      }
    }
    this.modalService.dismissAll();
  }

  Next(){
    this.finalSubmission=true;
    this.preventServiceDoubleClick=true;
    if(this.questionArray.length>0){
      const foundEmpty = this.questionArray.find((element:any) => (element.iMasterQuestionType<4 && element.answers.length==0) || (element.iMasterQuestionType==4 && element.hasOwnProperty('inputValue') && (element.inputValue==='' || element.inputValue===null || element.inputValue?.toString().includes('-') || element.inputValue?.toString().includes('.'))));

      if(foundEmpty){
        this.activeServiceIsSubmitted=false;
        // this.OpenServiceRequiredModal();
        // this.preventServiceDoubleClick=false;
      }else{
        this.activeServiceIsSubmitted=true;
      }
        this.UpdateServiceRequirementAnswers(this.activeServiceId,this.uniqueID,this.questionArray,true);
        this.preventServiceDoubleClick=false;
      }
  }
  
  getNotCompletedServices(serviceArray:any){
    let services="";
    serviceArray.map((obj:any,index:number)=>{
      if(index<serviceArray.length-1){
        services=services + obj?.vMasterServiceTitle + ", ";
      }else{
        services=services + obj?.vMasterServiceTitle;
      }
    });

    return services;
  }


  RedirectToNextStep(){
    const submissionPendingServices=this.selectedServiceList.filter((obj:any)=>obj.isSubmitted==false)

    if(submissionPendingServices.length>0){
      this.notFilled=submissionPendingServices;
      console.log(this.notFilled,"this.notFilled")
      this.OpenServiceRequiredModal();
      // this.notifyService.showError("Please answer all the questions from every service,all questions are mandatory!!!", '');
    }else{
      const newValue = Math.random() * 100;
      this.preventServiceDoubleClick=false;
      this.quotingService.updateEStepper(newValue);
    }
  }

  checkInputError(question:any){
    if(question.inputValue==='' || question.inputValue<0 || question.inputValue?.toString().includes('-') || question.inputValue?.toString().includes('.')){
      return true;
    }else{
      return false;
    }

  }
}
